import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { RadioElement, getDefaultCargoRequestValue, NOT_RESET_FIELDS, displayValue } from './common';
import { Checkbox, TextField } from 'material-ui';

import CollapseCustomizable from 'components/common/CollapseCustomizable';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import helpers from 'helpers';

function Loose({
    updateCargoOrder,
    numberOrderTable,
    cargoPackingIndex,
    cargoOrder,
    cargoPacking,
    canCheck = false,
}) {
    const [disabledAll, setDisableAll] = useState(false);

    useEffect(() => {
        if (cargoPacking.category !== 'loose') {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');
            
            NOT_RESET_FIELDS.forEach((field) => {
                metaPack[field] = cargoPacking.pack[field];
            });
            
            setDisableAll(true);
            modifyField('pack', metaPack);
        } else {
            setDisableAll(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    /**
     * r
     * @param {string} fieldPath field path 
     * @param {any} value 
     */
    const modifyField = (fieldPath, value) => {
        const newCargoOrder = _.cloneDeep(cargoOrder);
        _.set(newCargoOrder.cargo[cargoPackingIndex].packing, fieldPath, value);
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    const changeStackable = () => {
        const newStackableValue = !cargoPacking.pack.stackable.value;

        const newCargoOrder = _.cloneDeep(cargoOrder);

        newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable.value = newStackableValue;

        if (!newStackableValue) {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');

            newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable = metaPack.stackable;
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return (<div><CollapseCustomizable 
        _key='loose'
        head={
            <RadioElement 
                value='loose' 
                checkedValue={cargoPacking.category}
                disabled={!canCheck}
                onCheck={() => modifyField('category', 'loose')}
                label='loose' 
                _key='loose' 
            />
        }
        headStyle={{ borderBottom: '1px solid #E0E0E0' }}
        body={
            <React.Fragment>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.maxUnitLength.value',
                                disabledAll,
                            )}
                            hintText='Length, mm'
                            floatingLabelText='Length, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.maxUnitLength.value', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.maxUnitWidth.value',
                                disabledAll,
                            )}
                            hintText='Max Width, mm'
                            floatingLabelText='Max Width, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.maxUnitWidth.value', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.unitHeight.value',
                                disabledAll,
                            )}
                            hintText='Unit Height, mm'
                            floatingLabelText='Unit Height, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.unitHeight.value', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.unitDiam.value',
                                disabledAll,
                            )}
                            hintText='Max Diameter, mm'
                            floatingLabelText='Max Diameter, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                            }}
                            onChange={e => 
                                modifyField('pack.unitDiam.value', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.unitWeight.value',
                                disabledAll,
                            )}
                            hintText='Unit Weight, mt'
                            floatingLabelText='Unit Weight, mt'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.unitWeight.value', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Checkbox 
                            label='Stackable'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.value',
                                disabledAll,
                            )}
                            onCheck={changeStackable}
                            disabled={disabledAll}
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.stackable.tiers',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            hintText='Tiers'
                            floatingLabelText='Tiers'
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.stackable.tiers', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Checkbox 
                            label='Inter-tier dunn...'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.dunnaging',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            onCheck={
                                () => modifyField('pack.stackable.dunnaging', !cargoPacking.pack.stackable.dunnaging)
                            }
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <Checkbox 
                            label='Nested'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.nested',
                                disabledAll, false,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            onCheck={
                                () => modifyField('pack.stackable.nested', !cargoPacking.pack.stackable.nested)
                            }
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                </div>    
            </React.Fragment>
        }
    />
    </div>);
}

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        const cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
        return {
            cargoOrder,
            cargoPacking,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(Loose));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Loose.jsx